<!-- 注册登录页面 login 点击跳转学籍卡页面 code=102没有填写学籍卡  -->
<template>
  <div class="userData">
    <div class="welcomeDiv">
      <div class="welcomeWord">您好，欢迎回家</div>
      <div class="welcomeTip">与校友同向同行，共聚校友情</div>
    </div>
    <div class="userDataForm">
      <van-form label-width="300px">
        <van-field
          v-model="userData.name"
          label="您的姓名"
          placeholder="请输入您的真实姓名"
          :rules="[{ required: true, message: '请输入您的真实姓名' }]"
        />
        <div class="driverLine"></div>

        <van-field
          v-model="userData.phone"
          label="请输入授权电话"
          placeholder="请输入授权电话"
          :rules="[{ required: true, message: '请输入授权电话' }]"
        />
        <div class="driverLine"></div>

        <div class="sexSelect">
          <div class="labelName">性别</div>
          <div class="sixCardDiv">
            <div class="manCard" @click="selectMan">
              <div class="manSelectedImgDiv" v-show="userData.sex == '男'">
                <img
                  src="../../assets/image/btn_nanPhoto_nor.png"
                  alt=""
                  class="manSelectedImg"
                />
              </div>
              <div class="manNotSelectedImgDiv" v-show="userData.sex == '女'">
                <img
                  src="../../assets/image/btn_nanhui_nor.png"
                  alt=""
                  class="manNotSelectedImg"
                />
              </div>
              <div class="selectIconDiv" v-show="userData.sex == '男'">
                <img
                  src="../../assets/image/btn_xuanzhong_nor.png"
                  alt=""
                  class="selectIcon"
                />
              </div>
              <div class="notSelectIconDiv" v-show="userData.sex == '女'">
                <img
                  src="../../assets/image/btn_weixuan_nor.png"
                  alt=""
                  class="notSelectIcon"
                />
              </div>
            </div>
            <div class="womanCard" @click="selectWoman">
              <div class="womanSelectedImgDiv" v-show="userData.sex == '女'">
                <img
                  src="../../assets/image/btn_nvliang_nor.png"
                  alt=""
                  class="womanSelectedImg"
                />
              </div>
              <div class="womanNotSelectedImgDiv" v-show="userData.sex == '男'">
                <img
                  src="../../assets/image/btn_nv_hui_nor.png"
                  alt=""
                  class="womanNotSelectedImg"
                />
              </div>
              <div class="selectIconDiv" v-show="userData.sex == '女'">
                <img
                  src="../../assets/image/btn_xuanzhong_nor.png"
                  alt=""
                  class="selectIcon"
                />
              </div>
              <div class="notSelectIconDiv" v-show="userData.sex == '男'">
                <img
                  src="../../assets/image/btn_weixuan_nor.png"
                  alt=""
                  class="notSelectIcon"
                />
              </div>
            </div>
          </div>
        </div>

        <van-field
          v-model="userData.idcard"
          placeholder="请输入身份证号"
          :rules="idCardRules"
        >
          <template slot="label">
            <div>身份证号</div>
          </template>
          <template slot="label">
            <div class="tips">(必填项，填写正确的身份证号)</div>
          </template>
        </van-field>
        <div class="driverLine"></div>

        <van-field
          v-model="userData.studentNumber"
          label="学号（选填）"
          placeholder="请输入学号"
        />
        <div class="driverLine"></div>

        <van-field
          readonly
          clickable
          name="calendar"
          :value="userData.birthday"
          label="出生日期"
          placeholder="请选择"
          @click="birthdayShow = true"
        >
          <template slot="right-icon">
            <van-icon name="arrow" />
          </template>
        </van-field>
        <div class="driverLine"></div>
        <!-- 日期弹窗 -->
        <van-popup v-model="birthdayShow" position="bottom">
          <van-datetime-picker
            @confirm="onConfirm"
            show-toolbar
            @cancel="birthdayShow = false"
            type="date"
            title="选择年月日"
            v-model="dqDate"
            :min-date="minDate"
            :max-date="maxDate"

          />
        </van-popup>

        <van-field name="radio" label="常驻地区">
          <template #input>
            <van-radio-group v-model="selectCity" direction="horizontal">
              <van-radio name="国内">国内</van-radio>
              <van-radio name="国外">国外</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!-- 选择国内，展示选择框 -->
        <van-field
          readonly
          v-model="userData.city"
          placeholder="请选择"
          style="margin-top: 0"
          @click="cityShow = true"
          v-if="selectCity == '国内'"
        >
          <template slot="right-icon">
            <van-icon name="arrow" />
          </template>
        </van-field>
        <!-- 选择国外，展示输入框 -->
        <van-field
          v-model="userData.city"
          placeholder="请输入"
          style="margin-top: 0"
          v-if="selectCity == '国外'"
        >
        </van-field>
        <!-- 城市弹窗 -->
        <van-popup v-model="cityShow" position="bottom" round>
          <van-area
            title="常驻地区"
            :area-list="areaList"
            :columns-num="2"
            @cancel="cityShow = false"
            @confirm="confirmCity"
          />
        </van-popup>
        <div class="driverLine"></div>
      </van-form>
    </div>
    <div class="nextIconDiv" @click="submit">
      <img
        src="../../assets/image/btn_xiayibu_nor.png"
        alt=""
        class="nextIcon"
      />
    </div>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
export default {
  data() {
    return {
      userData: {
        name: "",
        phone: window.localStorage.getItem("phone") == 'undefined' ? "" : window.localStorage.getItem("phone"),
        sex: "男",
        idcard: "",
        studentNumber: "",
        birthday: "",
        city: "",
        province: "",
      },
      idCardRules: [
        {
          required: true,
        },
        {
          validator: (val) => {
            const ver15 =
              /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
            const ver18 =
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            return ver15.test(val) || ver18.test(val);
          },
          message: "身份证号码格式错误!",
        },
      ],
      areaList,
      selectCity: "国内",
      cityShow: false,
      birthdayShow: false,
      dqDate: "",
      cityList: "",
      minDate: '',
      maxDate: '',
    };
  },
  created() {
    const currentYear = new Date().getFullYear();
    const minCurrentYear = new Date().getFullYear()-80;
    const maxCurrentYear = new Date().getFullYear()+20;
    const month = new Date().getMonth();
    const date = new Date().getDate();
    this.dqDate = new Date(parseInt(currentYear),parseInt(month),parseInt(date));
    this.minDate = new Date(parseInt(minCurrentYear),0,1);
    this.maxDate = new Date(parseInt(maxCurrentYear),0,1);
  },
  methods: {
    selectMan() {
      this.userData.sex = "男";
    },
    selectWoman() {
      this.userData.sex = "女";
    },
    onConfirm(val) {
      this.userData.birthday = this.timeFormat(val);
      this.birthdayShow = false;
    },
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      return year + "-" + month + "-" + day;
    },
    confirmCity(val) {
      if (val[0].name.includes("市")) {
        this.userData.city = val[0].name;
        this.userData.province = val[0].name;
      } else {
        this.userData.city = val[1].name;
        this.userData.province = val[0].name;
      }
      this.cityShow = false;
    },
    submit() {
      if (
        this.userData.idcard !== "" &&
        this.userData.idcard.length !== 15 &&
        this.userData.idcard.length !== 18
      ) {
        this.$message("请填写有效的身份证信息");
        return;
      }
      if (this.userData.province === "") {
        if (
          this.userData.name === "" ||
          this.userData.phone === "" ||
          this.userData.birthday === "" ||
          this.userData.city === ""
        ) {
          this.$message("请填写信息");
        } else {
          this.gotoAtSchoolData();
        }
      } else {
        if (
          this.userData.name === "" ||
          this.userData.phone === "" ||
          this.userData.birthday === "" ||
          this.userData.city === "" ||
          this.userData.province === ""
        ) {
          this.$message("请填写信息");
        } else {
          this.gotoAtSchoolData();
        }
      }
    },
    gotoAtSchoolData() {
      window.sessionStorage.setItem("userData", JSON.stringify(this.userData));
      return this.$router.push({ path: "/atSchoolData" });
    },
  },
};
</script>

<style lang="less" scoped>
.userData {
  min-height: 100vh;
  background-color: #ffffff;

  .welcomeDiv {
    padding: 30px 5% 10px 5%;

    .welcomeWord {
      font-size: 2rem;
      font-weight: 400;
      color: #333333;
    }

    .welcomeTip {
      margin-top: 10px;
      font-weight: 400;
      color: #333333;
    }
  }

  .userDataForm {
    width: 90%;
    margin: 0 5%;

    .sexSelect {
      margin-top: 30px;

      .sixCardDiv {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .manCard,
        .womanCard {
          position: relative;
          width: 46%;
          border: 1px solid #aaaaaa;
          border-radius: 20px;
        }

        .manSelectedImgDiv,
        .manNotSelectedImgDiv,
        .womanSelectedImgDiv,
        .womanNotSelectedImgDiv {
          position: relative;
          left: 50%;
          top: 100%;
          transform: translate(-50%, -100%);
          padding-top: 4vw;
          width: 17vw;
          height: 23vw;

          .manSelectedImg,
          .manNotSelectedImg,
          .womanSelectedImg,
          .womanNotSelectedImg {
            width: 100%;
            height: 100%;
          }
        }

        .selectIconDiv,
        .notSelectIconDiv {
          position: absolute;
          right: 2vw;
          top: 2vw;
          width: 5vw;
          height: 5vw;

          .selectIcon,
          .notSelectIcon {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .birthdayDiv {
    margin-top: 15px;
  }

  .nextIconDiv {
    margin: 0 auto;
    padding: 20px 0;
    width: 20vw;
    height: 20vw;

    .nextIcon {
      width: 100%;
      height: 100%;
    }
  }
}

.driverLine {
  width: 100%;
  height: 1px;
  background: #aaaaaa;
}

.van-cell {
  margin-top: 30px !important;
  display: block !important;
  padding: 0 !important;
  font-size: 1.2rem !important;
}

.van-cell__title,
.labelName {
  font-weight: 400;
  font-size: 1.2rem;
  color: #333333;
}

.van-cell__value {
  font-size: 1.1rem;
  margin: 15px 1% 5px 1%;
  width: 98%;
}

.tips {
  margin-top: 10px;
  font-size: 0.9rem;
  font-weight: 400;
  color: #db1515;
  line-height: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/register/UserData.vue